/* eslint-disable */
import axios from 'axios'

import {
    SET_LOADER,
    GET_HEADCOUNT,
    GET_TOP_SOURCE,
    GET_TOTAL_EVENTS,
    GET_TOTAL_FILLED,
    GET_TOTAL_OPENINGS,
    GET_TOTAL_REMAINING,
} from 'store/actions/actionTypes'
import { getAuthToken } from 'store/authConfig'
import { addToast } from 'components/Toast/actions'

let counter = 0

const setLoader = loader => ({
    type: SET_LOADER,
    loader,
})

const getTotalEventsAction = data => ({
    type: GET_TOTAL_EVENTS,
    totalEvents: data,
})

const getTopSourceAction = data => ({
    type: GET_TOP_SOURCE,
    topSources: data,
})

const getHeadcountAction = data => ({
    type: GET_HEADCOUNT,
    headCount: data,
})

const getTotalFilledAction = data => ({
    type: GET_TOTAL_FILLED,
    totalFilled: data.remaining_positions__sum,
})

const getTotalOpeningsAction = data => ({
    type: GET_TOTAL_OPENINGS,
    totalOpenings: data?.total_positions__sum || 0,
})

const getTotalRemainingAction = data => ({
    type: GET_TOTAL_REMAINING,
    totalRemaining: data?.available_positions__sum || 0,
})

const errorHandler = error => dispatch => {
    if (error.response?.data.message) {
        dispatch(addToast('error', 'Error', error.response.data.message))
        dispatch(setLoader(false))
    }
    const message = error.message || 'Something went wrong, please try after sometime.'
    dispatch(addToast('error', 'Error', message))
    dispatch(setLoader(false))
}

const commonHandler = (queryParams, responseHandler, postData = {}) => {
    let url = `/api/jobs/chart`

    if (queryParams) url += `?${queryParams}`

    getAuthToken()
    return dispatch => {
        dispatch(setLoader(true))
        axios.post(url, postData)
            .then(response => {
                if (response.data.data) dispatch(responseHandler(response.data.data))
            })
            .catch(error => dispatch(errorHandler(error)))
            .finally(() => {
                counter -= 1
                if (counter === 0) dispatch(setLoader(false))
            })
    }
}

export const getTotalEvents = (postData = {}) => {
    counter += 1
    const queryParams = 'chartName=TotalEvents'
    return dispatch => dispatch(commonHandler(queryParams, getTotalEventsAction, postData))
}

export const getTopSource = (postData = {}) => {
    counter += 1
    const queryParams = 'chartName=TopSource'
    return dispatch => dispatch(commonHandler(queryParams, getTopSourceAction, postData))
}

export const getHeadcount = (postData = {}) => { 
    counter += 1
    const queryParams = 'chartName=HeadCount'
    return dispatch => dispatch(commonHandler(queryParams, getHeadcountAction, postData))
}

export const getTotalFilled = (postData = {}) => {
    counter += 1
    const queryParams = 'chartName=TotalFilled'
    return dispatch => dispatch(commonHandler(queryParams, getTotalFilledAction, postData))
}

export const getTotalOpenings = (postData = {}) => {
    counter += 1
    const queryParams = 'chartName=TotalOpening'
    return dispatch => dispatch(commonHandler(queryParams, getTotalOpeningsAction, postData))
}

export const getTotalRemaining = (postData = {}) => {
    counter += 1
    const queryParams = 'chartName=TotalRemaining'
    return dispatch => dispatch(commonHandler(queryParams, getTotalRemainingAction, postData))
}
